import React, { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";
import useMotionGuard from "../hooks/useMotionGuard";

/**
 * Cursor ring custom "Helios-style":
 * - segue il puntatore con spring
 * - si espande su elementi interattivi (a, button, input, textarea, [data-cursor="hover"])
 * - nascosto totalmente su touch device e prefers-reduced-motion
 */
export default function CursorRing() {
    const { disabled } = useMotionGuard();

    const x = useMotionValue(-100);
    const y = useMotionValue(-100);
    const sx = useSpring(x, { stiffness: 380, damping: 38, mass: 0.35 });
    const sy = useSpring(y, { stiffness: 380, damping: 38, mass: 0.35 });

    const [hover, setHover] = useState(false);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (disabled) return;

        const onMove = (e) => {
            x.set(e.clientX);
            y.set(e.clientY);
            if (!visible) setVisible(true);
        };
        const onOver = (e) => {
            const t = e.target;
            if (!t || !t.closest) return;
            const interactive = t.closest("a, button, input, textarea, select, [role='button'], [data-cursor='hover']");
            setHover(!!interactive);
        };
        const onLeaveDoc = () => setVisible(false);
        const onEnterDoc = () => setVisible(true);

        window.addEventListener("mousemove", onMove, { passive: true });
        window.addEventListener("mouseover", onOver, { passive: true });
        document.addEventListener("mouseleave", onLeaveDoc);
        document.addEventListener("mouseenter", onEnterDoc);
        return () => {
            window.removeEventListener("mousemove", onMove);
            window.removeEventListener("mouseover", onOver);
            document.removeEventListener("mouseleave", onLeaveDoc);
            document.removeEventListener("mouseenter", onEnterDoc);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [disabled]);

    if (disabled) return null;

    return (
        <motion.div
            className="lp-cursor-ring"
            aria-hidden="true"
            style={{ x: sx, y: sy, opacity: visible ? 1 : 0 }}
            animate={{
                scale: hover ? 1.9 : 1,
                borderColor: hover ? "rgba(229,255,0,0.95)" : "rgba(245,245,240,0.55)",
            }}
            transition={{ type: "spring", stiffness: 260, damping: 22 }}
        />
    );
}
